export default "__VITE_ASSET__CwS4yqrK__"